/*
    🔥 EJE DISPOSICIÓN DEL SHELL

    El octavo eje. Los otros ya existían:

      forma        -> radios, bordes, tipografía
      tipografía   -> familias
      color        -> claro / oscuro
      header       -> dónde va la navegación del header
      layout       -> DÓNDE VA TODO LO DEMÁS   ← este
      alert / confirm / editor

    ⚠️ QUÉ CAMBIA UN LAYOUT Y QUÉ NO

    Cambia la ESTRUCTURA: de qué lado va el sidebar, cuánto mide, si
    el contenido es ancho o angosto, si hay sidebar o no.

    NO cambia el contenido ni los componentes. Un mismo dashboard se
    ve en los once sin tocar una línea de la vista.

    ⚠️ POR QUÉ ES CSS Y NO COMPONENTES DISTINTOS

    Once layouts serían once componentes casi iguales. Con un atributo
    en el <html> y grid, el mismo markup se reacomoda. Agregar el
    doceavo es un bloque de CSS, no un archivo nuevo.

    sidebar : left | right | none | float
    width   : ancho del sidebar
    content : full | boxed | narrow
    density : normal | compact
*/

export const LAYOUT_TEMPLATES = [

    {
        id: 1, label: 'Sidebar izquierda',
        sidebar: 'left', width: 'md', content: 'full', density: 'normal',
        description: 'El clásico. Nav a la izquierda, contenido a lo ancho.',
    },

    {
        id: 2, label: 'Sidebar derecha',
        sidebar: 'right', width: 'md', content: 'full', density: 'normal',
        description: 'Nav a la derecha. Útil si el contenido se lee de izquierda a derecha y querés el menú fuera del camino.',
    },

    {
        id: 3, label: 'Sidebar compacta (íconos)',
        sidebar: 'left', width: 'icon', content: 'full', density: 'normal',
        description: 'Solo íconos; se expande al pasar el mouse. Gana ancho para tablas.',
    },

    {
        id: 4, label: 'Sidebar angosta',
        sidebar: 'left', width: 'sm', content: 'full', density: 'normal',
        description: 'Nav más finita para menús cortos.',
    },

    {
        id: 5, label: 'Sidebar ancha',
        sidebar: 'left', width: 'lg', content: 'full', density: 'normal',
        description: 'Para menús con muchos niveles o descripciones.',
    },

    {
        id: 6, label: 'Sin sidebar',
        sidebar: 'none', width: 'md', content: 'full', density: 'normal',
        description: 'Todo el ancho para el contenido. La navegación queda en el header.',
    },

    {
        id: 7, label: 'Contenido centrado',
        sidebar: 'left', width: 'md', content: 'boxed', density: 'normal',
        description: 'Sidebar más contenido con ancho máximo. Evita líneas de texto interminables.',
    },

    {
        id: 8, label: 'Lectura (angosto)',
        sidebar: 'left', width: 'sm', content: 'narrow', density: 'normal',
        description: 'Columna de lectura. Para documentación y artículos.',
    },

    {
        id: 9, label: 'Compacto',
        sidebar: 'left', width: 'sm', content: 'full', density: 'compact',
        description: 'Menos aire en todos lados. Para paneles con mucha densidad de datos.',
    },

    {
        id: 10, label: 'Sidebar flotante',
        sidebar: 'float', width: 'md', content: 'full', density: 'normal',
        description: 'El nav se abre por encima del contenido y se cierra al elegir.',
    },

    {
        id: 11, label: 'Sin sidebar + centrado',
        sidebar: 'none', width: 'md', content: 'boxed', density: 'normal',
        description: 'Landing de panel: sin nav lateral y contenido acotado.',
    },

];

export const LAYOUT_TEMPLATE_IDS = LAYOUT_TEMPLATES.map((item) => item.id);

const FALLBACK_TEMPLATE = LAYOUT_TEMPLATES[0];

export const onResolveLayoutTemplate = (id) => (
    LAYOUT_TEMPLATES.find((item) => item.id === Number(id)) ?? FALLBACK_TEMPLATE
);
